import Partners from './../components/Partners'
import { connect } from 'react-redux'
import { partners } from './../graphqlDic'
import { graphql, compose } from 'react-apollo'

export default compose(
    graphql(partners, {
        name:'partners'
    })
)(connect(null, null)(Partners))


// WEBPACK FOOTER //
// ./src/containers/Partners.js